whenAvailable('$',function() {
$(function(){
    whenAvailable('slick',function() {
        // Stamped Reviews
        var star_full = '<svg class="fa-c-star" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve"><polygon style="fill:#FFC107" points="25,1.33 32.69,17.91 49.88,18.41 37.44,31.54 40.38,48.67 25,40.58 9.62,48.67 12.56,31.54 0.12,18.41 17.31,17.91 "></polygon></svg>';
        var star_half = '<svg class="fa-c-star-half" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve"><polygon style="fill:#FFC107" points="25,1.33 17.31,17.91 0.12,18.41 12.56,31.54 9.62,48.67 25,40.58 "></polygon><g><path style="fill:#FFC107" d="M25,7.28l5.42,11.69l0.65,1.4l1.55,0.04l11.61,0.34l-8.6,9.07l-0.86,0.91l0.21,1.23l2.08,12.13l-10.89-5.73L25,37.76l-1.16,0.61L12.94,44.1l2.08-12.13l0.21-1.23l-0.86-0.91l-8.6-9.07l11.61-0.34l1.55-0.04l0.65-1.4L25,7.28 M25,1.33l-7.69,16.58l-17.19,0.5l12.44,13.13L9.62,48.67L25,40.58l15.38,8.09l-2.94-17.12l12.44-13.13l-17.19-0.5L25,1.33L25,1.33z"></path></g></svg>';
        function shuffle(array) {
            var currentIndex = array.length, temporaryValue, randomIndex;
            // While there remain elements to shuffle...
            while (0 !== currentIndex) {
                // Pick a remaining element...
                randomIndex = Math.floor(Math.random() * currentIndex);
                currentIndex -= 1;
                // And swap it with the current element.
                temporaryValue = array[currentIndex];
                array[currentIndex] = array[randomIndex];
                array[randomIndex] = temporaryValue;
            }
            return array;
        }

        generate_stamped_reviews(stamped_reviews);
        function generate_stamped_reviews(arr) {
            var urlParameters;
            var selected = shuffle(arr).slice(0,7);
            $.each(selected, function (i,v) {
                var addStars = star_full.repeat(Math.floor(v[4])); if ( v[4] % 1 == 0.5 ) { addStars += star_half };
                if (v[1].match(/[^0-9]/g) == null) {
                    urlParameters = 'href="'+ locale_root +'/pages/reviews?stamped_r_id='+ v[1] +'"';
                } else {
                    urlParameters = 'href="'+ v[1] +'" target="_blank" rel="noopener"';
                }
                $('#stamped_review_slick').append('<div class="index-reviews-post shadow rounded-3"><img data-src="'+ v[0] +'" alt="'+ v[2] +'\'s Review Image" class="review-img ms-0 mb-2 border lazy lazy-fade"><div class="review-title font-soleil strong mb-1">'+ v[5] +'</div><div class="review-stars mb-2">'+ addStars +'</div><div class="review-body">'+ v[6] +'</div><a '+ urlParameters +' class="review-link mb-2">Continue Reading</a><div class="review-author">'+ v[2] +'<span class="review-verified" data-bs-toggle="tooltip" data-bs-placement="top" title="Verified Buyer"><i class="fas fa-check-circle"></i></span></div><div class="review-country mb-0">'+ v[3] +'</div></div>');
            });
        }

        $('#stamped_review_slick')?.slick({
            prevArrow: '<button type="button" aria-label="Previous" class="review-prev"></button>',
            nextArrow: '<button type="button" aria-label="Next" class="review-next"></button>',
            infinite: false,
            autoplay: false,
            slidesToShow: 1,
            initialSlide: 2,
            centerMode: true,
            centerPadding: '5.25vw',
            mobileFirst: true,
            adaptiveHeight: true,
            dots: true,
            responsive: [
                {
                    breakpoint: 374,
                    settings: {
                        centerMode: true,
                        centerPadding: 'calc((100vw / 12) + 10px)'
                    }
                },
                {
                    breakpoint: 599,
                    settings: {
                        slidesToShow: 2,
                        centerPadding: 'calc((100vw / 12) + 10px)'
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                        centerPadding: 'calc((100vw / 12) + 5px)',
                        initialSlide: 1
                    }
                },
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 4,
                        centerPadding: 'calc((100vw / 12) + 5px)',
                        initialSlide: 3
                    }
                },
                {
                    breakpoint: 1499,
                    settings: {
                        slidesToShow: 4,
                        centerPadding: 'calc((100vw / 6) + 5px)',
                        initialSlide: 3
                    }
                }
            ]
        });
        whenAvailable('lazyload', function(){
            initLazyload();
        });
    });
});
});